import * as React from "react";
import { forwardRef } from "react";
const SvgCircleWarningIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 19, viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9 2C4.86 2 1.5 5.36 1.5 9.5C1.5 13.64 4.86 17 9 17C13.14 17 16.5 13.64 16.5 9.5C16.5 5.36 13.14 2 9 2ZM9 10.25C8.5875 10.25 8.25 9.9125 8.25 9.5V6.5C8.25 6.0875 8.5875 5.75 9 5.75C9.4125 5.75 9.75 6.0875 9.75 6.5V9.5C9.75 9.9125 9.4125 10.25 9 10.25ZM9.75 13.25H8.25V11.75H9.75V13.25Z", fill: "#F0504F" }));
const ForwardRef = forwardRef(SvgCircleWarningIcon);
export default ForwardRef;
